// extracted by mini-css-extract-plugin
export default {"component":"DivAndButton_component__t+ELp"};